export default __webpack_public_path__ + "img/33.168afb.png";